import type { CsmContactForm, PortalRequest, PortalView, UnknownSource } from './types';

export const INITIALIZATION_ACTIONS = {
	STARTED: 'started',
	FINISHED: 'finished',
	FAILED: 'failed',
};

export const OPERATIONAL_ACTIONS = {
	FAILED: 'failed',
	EDIT_FAILED: 'edit failed',
};

export const TRACK_ACTIONS = {
	EDITED: 'edited',
};

export const SOURCES: {
	PORTAL_REQUEST: PortalRequest;
	PORTAL_VIEW: PortalView;
	UNKNOWN_SOURCE: UnknownSource;
	CSM_CONTACT_FORM: CsmContactForm;
} = {
	PORTAL_REQUEST: 'portal-request',
	PORTAL_VIEW: 'portal-view',
	UNKNOWN_SOURCE: 'unknownSource',
	CSM_CONTACT_FORM: 'csm-contact-form',
};

export const RENDER_CONTEXTS: {
	PORTAL_REQUEST: PortalRequest;
	PORTAL_VIEW: PortalView;
	CSM_CONTACT_FORM: CsmContactForm;
} = {
	PORTAL_REQUEST: 'portal-request',
	PORTAL_VIEW: 'portal-view',
	CSM_CONTACT_FORM: 'csm-contact-form',
};

export const EXPERIENCES: {
	PORTAL_REQUEST: PortalRequest;
	PORTAL_VIEW: PortalView;
	CSM_CONTACT_FORM: CsmContactForm;
} = {
	PORTAL_REQUEST: 'portal-request',
	PORTAL_VIEW: 'portal-view',
	CSM_CONTACT_FORM: 'csm-contact-form',
};

export const FORGE_SAMPLING_RATE = 10; // every 10th event is sent
export const DEBOUNCE_INTERVAL = 10; // 10 ms

export const PACKAGE_NAME_GASV3 = 'jiraForgeUi';

export const MODULE_TYPE_EXTENSION = 'extension';

export const KNOWN_NETWORK_ERRORS = [
	'... is not valid JSON',
	'server with the specified hostname could not be found',
	'cannot parse response',
	'connection failure',
	'Failed to fetch',
	'in JSON at position 0',
	'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
	'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
	'Load failed',
	'Network request failed',
	'NetworkError',
	'Syntax or http error',
	'The request timed out',
	'The network connection was lost',
	'The operation was aborted',
	'Unable to fetch manifest',
	'Unexpected end of input',
	'Unexpected end of JSON input',
	'dynamically imported module',
	'Importing a module script failed',
];

export const AGG_UNDERLYING_SERVICE_TIMEOUT = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
export const KNOWN_NETWORK_ERRORS_TYPES = [
	'AbortError',
	'AuthError',
	'ChunkLoadError',
	'NetworkError',
];

export const commonErrors = {
	MUST_INCLUDE_ACCOUNT_ID:
		'Response ended with an error message: Requests from this source must include an accountId',
	OPERATION_ABORTED: 'The operation was aborted. ',
	CANCELLED: 'cancelled',
	UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
	NETWORK_CONNECTION_LOST: 'The network connection was lost.',
	TIMEOUT: 'The request timed out.',
	AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS:
		'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
	GATEWAY_TIMEOUT:
		'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504',
} as const;

export const userConsentErrorRegex = new RegExp('The user did not consent to use the app', 'i');
